<div class="add-comment-page">
    <header class="pt-5 text-center text-secondary container">
        <h1 class="pb-1 fs-3 fw-normal">
            {{'poll.comment.title' | translate}}
        </h1>
        <p class="col-md-4 mx-auto">{{'poll.comment.desc' | translate}}</p>
        <hr class="w-25 mx-auto pt-2">
    </header>

    
    <div id="container" class="container">
        <div class="row">
            <form class="form mt-4 col-md-9 mx-auto">
                <div class="mb-5 pb-0">
                    <div class="d-sm-flex flex-row-reverse justify-content-between text-secondary g-2 pb-3">
                        <h2 class="fs-5">{{poll?.team.name}}</h2>
                        <p class="fst-italic text-ligthgreen fs-6">
                            "{{poll?.label}}"
                        </p>
                    </div>
                    
                    <section class="">
                        <h3 class="text-secondary fs-5 fw-normal ps-2">{{'add_comment_comment'| translate}}</h3>
                        
                        <div class="mb-3 moods moods-comment-area pt-2">
                                <div class="moodpickers-wrapper">
                                    <tm-rich-text-area [(content)]="rtaContent"
                                                        [threadAuthors]="[]"
                                                        (contentChange)="onContentChange($event)"
                                                        [placeholderText]="'poll_comment_request.placeholder' | translate"/>
                                </div>

                                @if(linkPreviews?.length > 0){
                                    <div class="previews-area">
                                        <div>
                                            @for(linkPreview of linkPreviews; track linkPreview){
                                                <tm-link-preview [linkPreview]="linkPreview"></tm-link-preview>
                                            }
                                        </div>
                                    </div>
                                }
                                <div class="save-area d-flex justify-content-end">
                                    <button type="button" class="btn btn-primary py-2 px-4 me-2" data-cy="submit-comment" 
                                            [disabled]="isFieldEmplty"
                                            (click)="saveComment()">{{ 'add_comment_publish_comment' | translate }}
                                    </button>
                                </div>
                        </div>
                    </section>

                    <div class="text-end skip-nav">
                        <button class="border-0 bg-transparent p-2 text-secondary fst-italic fs-6"  
                                (click)="skipAddingComment()">
                                {{'add_comment.skip' | translate}} <i class="fa-solid fa-chevrons-right ps-2"></i>
                        </button>
                    </div>
                </div>
            </form>
            <div class="row mt-0 col-md-9 mx-auto mb-3 pb-5 row gx-5 informations">
                <div class="media col-md-6 d-flex">
                    <i class="far fa-mask fa-4x" aria-hidden="true"></i>
                    <div class="media-body px-3">
                        <h4 class="media-heading">{{'add_comment_anonymous' | translate}}</h4>
                        <p>{{'add_comment_information_anonymous' | translate}}</p>
                    </div>
                </div>
                <div class="media col-md-6 d-flex">
                    <i class="far fa-comment fa-4x" aria-hidden="true"></i>
                    <div class="media-body px-3">
                        <h4 class="media-heading">{{'add_comment_civil' | translate}}</h4>
                        <p>
                            {{'add_comment_informations_disclaimer' | translate}}
                            <a href="/{{poll?.team.id}}/codeofconduct" target="_blank">{{'add_mood_box.code_of_conduct' | translate}}</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>